import { render } from "./CustomerSort.vue?vue&type=template&id=97e5ba90&scoped=true"
import script from "./CustomerSort.vue?vue&type=script&lang=js"
export * from "./CustomerSort.vue?vue&type=script&lang=js"

import "./CustomerSort.vue?vue&type=style&index=0&id=97e5ba90&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e5ba90"]])

export default __exports__